import { createFileRoute } from '@tanstack/react-router';

import QuoteRequestLineItemsPage from '@/areas/quote-requests/QuoteRequests/QuoteRequestLineItemsPage/QuoteRequestLineItemsPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/line-items')(
    {
        staticData: {
            access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
            chrome: 'project',
        } satisfies PageStaticData,
        component: RouteComponent,
    },
);

function RouteComponent(): JSX.Element {
    const { projectId } = Route.useParams();
    return <QuoteRequestLineItemsPage context={{ type: 'Rfq', id: projectId }} />;
}
